var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageBox" },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("添加新网账户")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: { model: _vm.form, "label-width": "80px" },
            },
            [
              _c(
                "div",
                { staticClass: "pageSerch" },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card", attrs: { shadow: "never" } },
                    [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "600",
                              "font-size": "20px",
                            },
                          },
                          [_vm._v("基本信息")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "营业执照照片",
                            "label-width": "150",
                          },
                        },
                        [
                          _vm.disable == false
                            ? _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: _vm.uploadUrl,
                                    headers: _vm.deader,
                                    "show-file-list": false,
                                    accept: "image/*",
                                    "on-success": _vm.handleAvatarSuccess,
                                  },
                                },
                                [
                                  _vm.form.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        staticStyle: { width: "100px" },
                                        attrs: { src: _vm.form.url },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.url
                                    ? _c("div", { staticClass: "modelView1" }, [
                                        _vm._v("编辑"),
                                      ])
                                    : _c(
                                        "el-button",
                                        {
                                          staticStyle: { margin: "0 auto 0" },
                                          attrs: { type: "primary" },
                                        },
                                        [_vm._v("上传附件")]
                                      ),
                                ],
                                1
                              )
                            : _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.form.url,
                                  alt: "",
                                  "preview-src-list": [_vm.form.url],
                                },
                              }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "企业全称",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "经营证件类型",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "type", $$v)
                                      },
                                      expression: "form.type",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "营业执照号码",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.num,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "num", $$v)
                                      },
                                      expression: "form.num",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "行业代码",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "code", $$v)
                                      },
                                      expression: "form.code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "实际经营地址",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.address,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "address", $$v)
                                      },
                                      expression: "form.address",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "对公户开户行名称",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.bankName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "bankName", $$v)
                                      },
                                      expression: "form.bankName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "对公户开户行号码",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.bankNum,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "bankNum", $$v)
                                      },
                                      expression: "form.bankNum",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "企业对公账户号",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.bankNum1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "bankNum1", $$v)
                                      },
                                      expression: "form.bankNum1",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "账户名称",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.balanceName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "balanceName", $$v)
                                      },
                                      expression: "form.balanceName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "账户说明",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.balanceMark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "balanceMark", $$v)
                                      },
                                      expression: "form.balanceMark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    {
                      staticClass: "box-card",
                      staticStyle: { margin: "10px 0" },
                      attrs: { shadow: "never" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "15px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        "font-size": "20px",
                                      },
                                    },
                                    [_vm._v("法人信息")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人身份证照片",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _vm.disable == false
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "avatar-uploader",
                                          attrs: {
                                            action: _vm.uploadUrl,
                                            headers: _vm.deader,
                                            "show-file-list": false,
                                            "on-success":
                                              _vm.handleAvatarSuccess1,
                                            accept: "image/*",
                                          },
                                        },
                                        [
                                          _vm.form.url1
                                            ? _c("img", {
                                                staticClass: "avatar",
                                                staticStyle: { width: "100px" },
                                                attrs: { src: _vm.form.url1 },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.form.url1
                                            ? _c(
                                                "div",
                                                { staticClass: "modelView1" },
                                                [_vm._v("编辑")]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "0 auto 0",
                                                  },
                                                  attrs: { type: "primary" },
                                                },
                                                [_vm._v("身份证正面照")]
                                              ),
                                        ],
                                        1
                                      )
                                    : _c("el-image", {
                                        staticStyle: {
                                          width: "150px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: _vm.form.url1,
                                          alt: "",
                                          "preview-src-list": [_vm.form.url1],
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm.disable == false
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "avatar-uploader",
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            accept: "image/*",
                                            action: _vm.uploadUrl,
                                            headers: _vm.deader,
                                            "show-file-list": false,
                                            "on-success":
                                              _vm.handleAvatarSuccess2,
                                          },
                                        },
                                        [
                                          _vm.form.url2
                                            ? _c("img", {
                                                staticClass: "avatar",
                                                staticStyle: { width: "100px" },
                                                attrs: { src: _vm.form.url2 },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.form.url2
                                            ? _c(
                                                "div",
                                                { staticClass: "modelView1" },
                                                [_vm._v("编辑")]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "0 auto 0",
                                                  },
                                                  attrs: { type: "primary" },
                                                },
                                                [_vm._v("身份证反面照")]
                                              ),
                                        ],
                                        1
                                      )
                                    : _c("el-image", {
                                        staticStyle: {
                                          width: "150px",
                                          height: "100px",
                                          "margin-left": "10px",
                                        },
                                        attrs: {
                                          src: _vm.form.url2,
                                          alt: "",
                                          "preview-src-list": [_vm.form.url2],
                                        },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人姓名",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.name1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name1", $$v)
                                      },
                                      expression: "form.name1",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人证件类型",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.type1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "type1", $$v)
                                      },
                                      expression: "form.type1",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人身份证号",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.Idcard,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Idcard", $$v)
                                      },
                                      expression: "form.Idcard",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人手机号",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "phone", $$v)
                                      },
                                      expression: "form.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "15px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        "font-size": "20px",
                                      },
                                    },
                                    [_vm._v("联系人信息")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人身份证照片",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _vm.disable == false
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "avatar-uploader",
                                          attrs: {
                                            action: _vm.uploadUrl,
                                            headers: _vm.deader,
                                            "show-file-list": false,
                                            "on-success":
                                              _vm.handleAvatarSuccess3,
                                            accept: "image/*",
                                          },
                                        },
                                        [
                                          _vm.form.url3
                                            ? _c("img", {
                                                staticClass: "avatar",
                                                staticStyle: { width: "100px" },
                                                attrs: { src: _vm.form.url3 },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.form.url3
                                            ? _c(
                                                "div",
                                                { staticClass: "modelView1" },
                                                [_vm._v("编辑")]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "0 auto 0",
                                                  },
                                                  attrs: { type: "primary" },
                                                },
                                                [_vm._v("身份证正面照")]
                                              ),
                                        ],
                                        1
                                      )
                                    : _c("el-image", {
                                        staticStyle: {
                                          width: "150px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: _vm.form.url3,
                                          alt: "",
                                          "preview-src-list": [_vm.form.url3],
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm.disable == false
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "avatar-uploader",
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            action: _vm.uploadUrl,
                                            headers: _vm.deader,
                                            accept: "image/*",
                                            "show-file-list": false,
                                            "on-success":
                                              _vm.handleAvatarSuccess4,
                                          },
                                        },
                                        [
                                          _vm.form.url4
                                            ? _c("img", {
                                                staticClass: "avatar",
                                                staticStyle: { width: "100px" },
                                                attrs: { src: _vm.form.url4 },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.form.url4
                                            ? _c(
                                                "div",
                                                { staticClass: "modelView1" },
                                                [_vm._v("编辑")]
                                              )
                                            : _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "0 auto 0",
                                                  },
                                                  attrs: { type: "primary" },
                                                },
                                                [_vm._v("身份证反面照")]
                                              ),
                                        ],
                                        1
                                      )
                                    : _c("el-image", {
                                        staticStyle: {
                                          width: "150px",
                                          height: "100px",
                                          "margin-left": "10px",
                                        },
                                        attrs: {
                                          src: _vm.form.url4,
                                          alt: "",
                                          "preview-src-list": [_vm.form.url4],
                                        },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人姓名",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.name2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name2", $$v)
                                      },
                                      expression: "form.name2",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人证件类型",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.type2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "type2", $$v)
                                      },
                                      expression: "form.type2",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人身份证号",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.Idcard2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Idcard2", $$v)
                                      },
                                      expression: "form.Idcard2",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人手机号",
                                    "label-width": "150",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: _vm.disable },
                                    model: {
                                      value: _vm.form.phone2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "phone2", $$v)
                                      },
                                      expression: "form.phone2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "box-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _vm._l(
                                _vm.form.enterpriseBeneficiaryInfos,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "15px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                "font-size": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "最终收益人信息(" +
                                                  _vm._s(index + 1) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人名称",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人证件类型",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryIdCardType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryIdCardType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryIdCardType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人证件号码",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryIdCardNo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryIdCardNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryIdCardNo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人联系电话",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryIdContactPhone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryIdContactPhone",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryIdContactPhone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人证件起始日期",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.disable,
                                              placeholder: "如：20250101",
                                            },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryIdCardValidStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryIdCardValidStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryIdCardValidStartDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业最终受益人证件截止日期",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.disable,
                                              placeholder: "如：20250101",
                                            },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryIdCardValidDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryIdCardValidDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryIdCardValidDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "最终受益人联系地址",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseBeneficiaryAddress,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseBeneficiaryAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseBeneficiaryAddress",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "最终受益人受益方式",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择受益方式",
                                                disabled: _vm.disable,
                                              },
                                              model: {
                                                value:
                                                  item.enterpriseBeneficiaryIncomeType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "enterpriseBeneficiaryIncomeType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.enterpriseBeneficiaryIncomeType",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    "直接或间接控股25%（含）以上",
                                                  value: "A01",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    "通过人事、财务等其他方式对公司进行控制",
                                                  value: "A02",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "高级管理人员",
                                                  value: "A03",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "法人或公司负责人",
                                                  value: "A04",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "其他",
                                                  value: "A05",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.disable == false
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { margin: "0 auto 0" },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addInfo()
                                            },
                                          },
                                        },
                                        [_vm._v("添加")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { width: "40%" } },
                            [
                              _vm._l(
                                _vm.form.enterpriseShareholderList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "15px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                "font-size": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "企业股东信息(" +
                                                  _vm._s(index + 1) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业控股股东名称",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseShareholderName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseShareholderName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseShareholderName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业控股股东证件类型",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择证件类型",
                                                disabled: _vm.disable,
                                              },
                                              model: {
                                                value:
                                                  item.enterpriseShareholderIdCardType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "enterpriseShareholderIdCardType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.enterpriseShareholderIdCardType",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "营业执照",
                                                  value: "A18",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "身份证",
                                                  value: "B01",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "护照",
                                                  value: "B04",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业控股股东证件号码",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: _vm.disable },
                                            model: {
                                              value:
                                                item.enterpriseShareholderIdCardNo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseShareholderIdCardNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseShareholderIdCardNo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业控股股东证件起始日期",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.disable,
                                              placeholder: "如：20250101",
                                            },
                                            model: {
                                              value:
                                                item.enterpriseShareholderIdCardValidStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseShareholderIdCardValidStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseShareholderIdCardValidStartDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "企业控股股东证件截止日期",
                                            "label-width": "150",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.disable,
                                              placeholder: "如：20250101",
                                            },
                                            model: {
                                              value:
                                                item.enterpriseShareholderIdCardValidDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "enterpriseShareholderIdCardValidDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.enterpriseShareholderIdCardValidDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.disable == false
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { margin: "0 auto 0" },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addInfo1()
                                            },
                                          },
                                        },
                                        [_vm._v("添加")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.disable
                    ? _c(
                        "el-card",
                        {
                          staticClass: "box-card",
                          staticStyle: {
                            "margin-top": "10px",
                            "text-align": "center",
                          },
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { margin: "0 auto 0" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.onSubmit },
                                },
                                [_vm._v("提交开户")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }